import { Grid } from '@mui/material';
import { getIn } from 'formik';

import { FormAutocompleteField, FormDateField, FormRichTextField } from '../../../../../common';
import { DATE_DISPLAY_FORMAT } from '../../../../../../constants';
import { disabledFutureDate } from '../../../../../../helpers';
import { ASSESSMENT_TOOL_OPTIONS } from '../constants';
import { getAssessmentMethodTemplateValues } from '../utils';

import type { AssessmentMethodFieldsProps } from './types';

export default function AssessmentMethodFields({
  formik,
  disabled,
  readOnly,
  templates,
  saveField,
}: AssessmentMethodFieldsProps) {
  const templateValues = getAssessmentMethodTemplateValues(getIn(formik.values, 'tool'), templates);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Tool used"
          name="tool"
          onChange={saveField}
          options={ASSESSMENT_TOOL_OPTIONS}
          placeholder="Select tool"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDateField
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          format={DATE_DISPLAY_FORMAT}
          label="Assessment date"
          name="assessment_date"
          onChange={saveField}
          placeholder="Select date"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Rationale for assessment"
          name="rationale"
          onBlur={saveField}
          placeholder="Describe the rationale for assessment selection based on age group"
          readOnly={readOnly}
          required
          showTemplateButton
          templateValue={templateValues.rationale}
        />
      </Grid>
      <Grid item xs={12}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Rationale for assessment selection"
          name="selection_rationale"
          onBlur={saveField}
          placeholder="Describe the rationale for assessment selection based on symptoms - patient symptoms noted that supported assessment selection"
          readOnly={readOnly}
          required
          showTemplateButton
          templateValue={templateValues.selection_rationale}
        />
      </Grid>
      <Grid item xs={12}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Tool description and modules used"
          name="tool_description"
          onBlur={saveField}
          placeholder="Describe the tool used"
          readOnly={readOnly}
          required
          showTemplateButton
          templateValue={templateValues.tool_description}
        />
      </Grid>
      <Grid item xs={12}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Describe the client score"
          name="client_score"
          onBlur={saveField}
          placeholder="Describe the client score (have all scoring presented correctly based on the way the assessment is scored)"
          readOnly={readOnly}
          required
          showTemplateButton
          templateValue={templateValues.client_score}
        />
      </Grid>
    </Grid>
  );
}
